export interface Supplier {
  id?: number;
  supplierId: number;
  name: string;
  lastUserModified?: string;
  lastModified?: string;
}

export interface SupplierWithStats extends Supplier {
  stats: Stats;
}

export interface Stats {
  averageMargin?: number;
  marginBasedOnNSpecials: number;
  minMargin?: number;
  maxMargin?: number;
}

export const EmptySupplier = (): Supplier => ({
  supplierId: 0,
  name: '',
});

export const EmptyStats = (): Stats => ({
  marginBasedOnNSpecials: 0,
});
